import { render, staticRenderFns } from "./tel-person-case-manage.vue?vue&type=template&id=2d50f350&scoped=true"
import script from "./tel-person-case-manage.vue?vue&type=script&lang=ts"
export * from "./tel-person-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50f350",
  null
  
)

export default component.exports